import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-justificativa-modal',
  templateUrl: './justificativa-modal.component.html',
  styleUrls: ['./justificativa-modal.component.scss']
})
export class JustificativaModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  tipo; // 0 - justificativa acompanhamento | 1 - justificativa fila
  justificativa = '';
  idCupom = '';


  constructor(public dialogRef: MatDialogRef<JustificativaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.idCupom = this.data.idCupom;
    this.tipo = this.data.tipo;
  }

  confirmar() {
    this.dialogRef.close(this.justificativa);
  }

  fechar() {
    this.dialogRef.close();
  }

}
